'use client';
import { message, Spin } from 'antd';
import styles from './addPost.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import PostDesktopFormComp from './desktopForm/desktopForm.index';
import { RestAPI, useBP } from 'scripts';
import PostMobileForm2Comp from './mobileFrom/mobileFrom2.index';
import { useEffect, useState } from 'react';
import { PostType } from 'types';
import { API } from 'data';
import PostFormMainComp from './mobileFrom/main/main.index';
// import { TbAlertCircleFilled } from 'react-icons/tb';

function PostFormComp() {
    const isMobile = useBP()?.MD_LTE;
    const { slug } = useParams();
    const nav = useNavigate();
    const [data, setData] = useState<PostType<'detail'>>();

    useEffect(() => {
        if (slug)
            RestAPI.get<PostType<'detail'>>(API.posts.myPostDetail(slug))
                .then((res) => {
                    setData(res.data);
                })
                .catch(() => {
                    message.error('خطایی رخ داده است. لطفا مجددا تلاش نمایید');
                    nav(-1);
                });
    }, []);

    if (slug && !data)
        return (
            <div className={`w-100 pv-9 center-content flex-1`}>
                <Spin />
            </div>
        );

    return (
        <div className={`${styles['add-form-container']}`}>
            {data ? (
                <>{isMobile ? <PostFormMainComp data={data} /> : <PostDesktopFormComp data={data} />}</>
            ) : (
                <>{!isMobile ? <PostDesktopFormComp /> : <PostMobileForm2Comp />}</>
            )}
        </div>
    );
}

export default PostFormComp;
